"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_PAYLOAD_SIZE = exports.IDEAL_PAYLOAD_SIZE = exports.FEATURE_NAME = void 0;
var _features = require("../../loaders/features/features");
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.genericEvents;
const IDEAL_PAYLOAD_SIZE = exports.IDEAL_PAYLOAD_SIZE = 64000;
const MAX_PAYLOAD_SIZE = exports.MAX_PAYLOAD_SIZE = 1000000;